import React, { useState } from 'react';
import { Box, Container, Typography, TextField, Button, Alert } from '@mui/material';
import axios from 'axios';
import useSEO from '../hooks/useSEO';
import { API_URL } from '../config/api';

const ForgotPasswordPage: React.FC = () => {
    useSEO({ title: 'بازیابی رمز عبور', noindex: true });
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setMessage('');

        try {
            const res = await axios.post(`${API_URL}/auth/forgot-password`, { email });
            setMessage(res.data.message);
        } catch (err: any) {
            setError(err.response?.data?.error || 'An error occurred. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container maxWidth="sm" sx={{ py: 8 }}>
            <Typography variant="h4" component="h1" align="center" gutterBottom>
                Forgot Password
            </Typography>
            <Typography variant="body1" align="center" color="text.secondary" paragraph>
                Enter your email address and we'll send you a link to reset your password.
            </Typography>

            {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

            <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
                <TextField
                    fullWidth
                    label="Email Address"
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    margin="normal"
                />
                <Button
                    fullWidth
                    type="submit"
                    variant="contained"
                    size="large"
                    disabled={loading}
                    sx={{ mt: 3 }}
                >
                    {loading ? 'Sending...' : 'Send Reset Link'}
                </Button>
            </Box>
        </Container>
    );
};

export default ForgotPasswordPage;
